const configs = {
  development: {
    aws_project_region: "us-east-1",
    aws_cognito_region: "us-east-1",
    aws_user_pools_id: "us-east-1_dpV9HR5V3",
    aws_user_pools_web_client_id: "4bil1buq9q4pn89r4tkgjbst9d"
  },
  staging: {
    aws_project_region: "us-east-1",
    aws_cognito_region: "us-east-1",
    aws_user_pools_id: "us-east-1_19nQmEcnh",
    aws_user_pools_web_client_id: "151oqgjaqn8b8ukki3h53cfms4"
  },
  production: {
    aws_project_region: "us-east-1",
    aws_cognito_region: "us-east-1",
    aws_user_pools_id: "us-east-1_KpWRJ5Y1B",
    aws_user_pools_web_client_id: "6c7bvte6j78lk5kpirkrb7ho0e"
  }
};

export default configs[process.env.REACT_APP_ENV || "development"];
